import { Numerals } from "@/types/Numerals";

export const translateNumerals = (num: number | bigint | string, numerals: Numerals) => {
  const numStr = num.toString();
  const numArr = numStr.split("");

  return numArr
    .map((char) => {
      const num = parseInt(char);
      if (isNaN(num)) {
        return char;
      }

      return numerals[num];
    })
    .join("");
};
